import moment from 'moment';
import {
  PropertyManagerContact,
  PropertyManagerRow,
} from './types';

export const toPropertyManagerRow = (
  contact: PropertyManagerContact
): PropertyManagerRow => {
  const lastLoggedOnFormatted = contact.lastLoggedOn
    ? moment(contact.lastLoggedOn).format('dddd MM/DD/YYYY')
    : 'Never';

  return {
    ...contact,
    lastLoggedOnFormatted,
  };
};
